import useBlockContext from '../Block/useBlockContext';

const useIsHover = () => {
  // NOTE: there are chances that Img use not only block context in the future
  // as Img theoretically could be the child of other container which might be stateful
  // like CarouselSection
  const blockContext = useBlockContext();
  if (!blockContext) {
    return false;
  }

  return blockContext.isHover;
};

export default useIsHover;
